import React, { Component } from 'react';
import TabContainer from './tabs/TabContainer';
import Background from './resources/img/danTrav.png';
import ContainerPaper from './components/paper/ContainerPaper';
import {desktopContentContainerPaperStyle } from './styles/shared/desktop';
import TemporaryBackground from './resources/img/header_bg.jpg';

const styles = {
  desktopBackground: {
    width: '100%',
    // backgroundImage: `url(${Background})`,
    // backgroundRepeat: 'no-repeat',
    // backgroundAttachment: 'fixed',
    // backgroundPosition: 'center top 50%',
    backgroundSize: 'cover',
    backgroundColor: 'black'
     
      
  },
  mobileBackground: {

    width: '100%',
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center top 50%',
    backgroundSize: '100%',
    backgroundColor: 'black'
    
},
temporartyBackground:{
  width: '100%',
  backgroundColor: 'black',
  color: 'white',
  height : '100vh',
  textAlign: 'center'
},
temporartyPaperContainer:{
  borderRadius: '20px',
},
temporaryPlaceHolderContainer:{
  backgroundImage: `url(${TemporaryBackground})`,
  backgroundSize: '100% 400px',       
  width: '100%',
  height: '300px',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)'
},
temporaryBannerTextPTag:{
  width: '100%',
  position: 'absolute',
  left: '50%',
  top: '45px',
  transform: 'translate(-50%, -50%)',
  color:'#358ae8',
  fontSize: '25px'

},
  cardStyle: {
    background: '#99DDDE'
  }
};
class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      deviceType: ''
    }
    this.renderDeviceType = this.renderDeviceType.bind(this);
  }

  renderDeviceType() {
    //>1024 desktop, 768<x<1024 tablet, >768 mobile if this is even needed.
    // if(window.innerWidth <=845){
    //   this.setState({deviceType: 'mobile'});
    // }else if(window.innerWidth > 1290){
    //   this.setState({deviceType: 'desktop'});
    // }else if(window.innerWidth > 845 && window.innerWidth <= 1290){
    //   this.setState({deviceType: 'tablet'});
    // }
    this.setState({deviceType: 'desktop'});

  }

  componentWillMount() {
    document.body.style.margin = 0;
    this.renderDeviceType();
    window.addEventListener("resize", this.renderDeviceType);
  }

  componentWillUnmount() {
    document.body.style.margin = '8px';
    window.removeEventListener("resize", this.renderDeviceType);
  }

  


  render() {
    return (
      <div id="main-container" className="App" style={styles.temporartyBackground}>
        {/* <Header /> */}        
        {/* <TabContainer deviceType={this.state.deviceType} /> */}
        <div style={styles.temporaryPlaceHolderContainer}>
          <div style={styles.temporaryBannerTextPTag}> A new experience is coming...</div>
        </div>
       
      </div>
    );
  }
}

export default App;
{/* <ContainerPaper id='summay-page-sub-container' style={styles.temporartyPaperContainer}>
               
</ContainerPaper> */}


// WEBPACK FOOTER //
// ./src/App.js